import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Message, Thread } from 'app/messages/message-service/message.model';
import { Borrower } from 'app/modules/borrower/models/borrower/borrower.model';
import { environment } from 'environments/environment';
import _ from 'lodash';
import { Contact } from 'app/models/dto/contact.model';

@Component({
  selector: 'app-marketing-email-message',
  templateUrl: './marketing-email-message.component.html',
  styleUrls: ['./marketing-email-message.component.scss']
})
export class MarketingEmailMessageComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() message: Message;
  @Input() thread: Thread;
  @Input() isLast: boolean;
  @Input() borrower: Borrower;
  @Input() joinedContacts: Contact[];
  @Output() handleEmailCreate = new EventEmitter();
  @Output() scrollIntoView = new EventEmitter();

  @ViewChild('lastMessageFocus') lastMessageFocus: ElementRef;

  messageCreateTypeValue: string = '';

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (this.isLast) {
      this.scrollIntoView.emit(this.lastMessageFocus.nativeElement.scrollHeight);
    };
  }

  setMessageCreateType(value: string) {
    this.messageCreateTypeValue = value;
  }

  downloadAttachment(attachmentId: number): void {
    const url = `${environment.API_URL}/document/${attachmentId}?stream=1&method=attachment`;
    window.location.href = url;
  }

  ngOnDestroy(): void {
    this.messageCreateTypeValue = '';
  }

}
